export const VRS_TERMS_LINK =
  'https://sorenson.com/wp-content/uploads/2022/11/2017-04-28-Sorenson-Individual-EULA-prevailing-language.pdf';
export const VRI_TERMS_LINK =
  'https://sorenson.com/wp-content/uploads/2022/11/SorensonCommunications-VRI-EULA-FINAL2022-11.pdf';
